import type { RisingStarBonusCurrent } from 'services/hooks/risingStarBonus';

import { useRisingStarCopy } from './copy';
import { formatAmount } from './format';
import AmountValue from '../shared/AmountValue';
import { SInformationItemWrapper } from '../shared/style';

/** 계산 과정 (정책 B-1 "계산치 표시"). 모든 값은 응답 그대로 — 여기서 계산하지 않는다 */
export default function BonusCalculation({ current, isBlur }: { current: RisingStarBonusCurrent; isBlur: boolean }) {
  const COPY = useRisingStarCopy();
  const { calculation } = current;

  return (
    <section aria-label={COPY.calcTitle}>
      <SInformationItemWrapper>
        <span>{COPY.totalReward}</span>
        <AmountValue amountFormat={formatAmount(calculation.totalReward)} isBlur={isBlur} />
      </SInformationItemWrapper>
      <SInformationItemWrapper>
        <span>{COPY.appliedTier}</span>
        <span className="bold">
          {calculation.tierThreshold === null ? COPY.notAchieved : COPY.tierRange(calculation.tierThreshold)}
        </span>
      </SInformationItemWrapper>
      <SInformationItemWrapper>
        <span>{COPY.appliedRule}</span>
        <span className="bold">{COPY.ruleLabel[calculation.rule]}</span>
      </SInformationItemWrapper>
      <SInformationItemWrapper $invisibleBorderBottom>
        <span>{COPY.bonus}</span>
        {/* 수정값이 있으면 수정값 — 상단 amount 와 같은 값. 미지급이면 상단처럼 취소선 (지급액처럼 보이지 않게) */}
        {current.status === 'CANCELLED' ? (
          <del>
            <AmountValue amountFormat={formatAmount(calculation.finalBonus)} isBlur={isBlur} />
          </del>
        ) : (
          <AmountValue amountFormat={formatAmount(calculation.finalBonus)} isBlur={isBlur} />
        )}
      </SInformationItemWrapper>
    </section>
  );
}
